import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { LazyTab } from 'shared/features/lazy';
import { SmallTabs } from 'console/tabs/small';
import { MediumTabs } from 'console/tabs/medium';
import { TabContext } from 'console/navigation/context/type';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { useIsServiceMode } from 'shared/contexts/device/state/is-service-view-selector';
import { useKeybind } from './model/use-keybind';
export const DeviceContent = memo(function DeviceContent(props) {
    const { ui, large, bannersHeight } = props;
    const { device, legacy_device, shown_tabs, selected_tab } = useContext(TabContext);
    const { simple_view_mode } = useAppSelector(select_ui_settings);
    const is_service_mode = useIsServiceMode(device?.id);
    if (device == null || legacy_device == null) {
        return null;
    }
    const pages = shown_tabs.map((tab) => {
        const simpleMode = simple_view_mode?.[device.id]?.[tab.key]?.enabled;
        return {
            visible: tab == selected_tab,
            content: (_jsx(LazyTab, { tabKey: tab.key, render: tab.render, ui: ui, large: large, device: legacy_device, r_device: device, active: tab.key === selected_tab.key, "data-tab_key": tab.key }, `${device.id}-${tab.key}-${simpleMode}-${is_service_mode}`)),
            tab_name: tab.key,
        };
    });
    const Tabs = large ? MediumTabs : SmallTabs;
    useKeybind();
    return _jsx(Tabs, { pages: pages, bannersHeight: bannersHeight });
});
